import React from 'react';
import { Grid, Box } from '@availity/element';

import { avLogo } from '@/static';

const AvailityHeaderLogo = () => (
  <Grid mt="auto" mb={2}>
    <Box textAlign="center">
      <img
        src={avLogo}
        alt="Availity Logo"
        style={{
          maxWidth: '250px',
        }}
      />
    </Box>
  </Grid>
);

export default AvailityHeaderLogo;
